
<span v-if="loading" class="skeleton-loader-background"></span>
<span v-else><slot /></span>
